<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <Caption label="CAPBL[iOS화면캡처 방지SDK]" />

        <div class="desc">
          아이폰 캡처 방지 솔루션입니다. 간단한 코드 몇 줄과 라이브러리로 아이폰 화면을 캡처할 수 없도록 합니다. <br/>
          보안이 중요한 그룹웨어, 인터넷 컨텐츠 무단 배포를 원치 않는 웹북 등에서 사용합니다
        </div>

        <div class="link">
          <a href="https://mondayless.notion.site/Capbl-871bed30eeb24fd583c3b8519db7d3d9" target="_blank">capbl.mondayless.co.kr</a>
        </div>


        
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
import SectionTechItem from "./SectionTechItem.vue";
export default {
  components: {
    Caption,
    SectionTechItem,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: fit-content;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding: 100px 20px 100px 20px;
}

.title_box {
  width: 272px;
}
ul {
  margin-bottom: 80px;
  width: 100%;
  justify-content: space-between;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}

ul li {
  margin-top: 50px;
  display: inline-block;
}

.link {
  margin-top: 20px;
  font-weight: 300;
  font-size: 20px;
  color: #000000;
}

.desc {
  margin-top: 50px;
  font-weight: 300;
  font-size: 20px;
  color: #000000;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: fit-content;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 100px 20px 100px 20px;
  }

  .title_box {
    width: 272px;
  }
  ul {
    margin-bottom: 80px;
    width: 100%;
    list-style-type: none;
    display: block;
    text-align: center;
  }

  ul li {
    margin-top: 50px;
    width: fit-content;
    display: block;
    text-align: center;
  }
}
</style>
  